<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Billing &amp; Order History</h4>
            <p class="category">Your billing and order history</p>
          </md-card-header>
          <md-card-content>
            <billing-history-table />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import billingHistoryTable from "./Tables/billingHistoryTable.vue";
export default {
  components: { billingHistoryTable },
  data() {
    return {};
  }
};
</script>
